import { z } from 'zod';

import { userSchema } from '@/entities/user/types';

export const loginSchema = z.object({
  email: z.email({ message: 'Ingresa un correo válido' }),
  password: z
    .string()
    .min(6, { message: 'La contraseña debe tener mínimo 6 caracteres' }),
});

export const loginResponseSchema = z.object({
  accessToken: z.string(),
  user: userSchema,
});

export const changePasswordSchema = z
  .object({
    currentPassword: z
      .string()
      .min(1, { message: 'Ingresa tu contraseña actual' }),
    newPassword: z
      .string()
      .min(8, { message: 'La nueva contraseña debe tener mínimo 8 caracteres' }),
    confirmPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Las contraseñas no coinciden',
    path: ['confirmPassword'],
  });

/**
 * Backend variant — solo currentPassword + newPassword.
 * `confirmPassword` es validación cliente, no se envía a la API.
 */
export const changePasswordPayloadSchema = z.object({
  currentPassword: z.string().min(1),
  newPassword: z.string().min(8),
});

export type LoginInput = z.infer<typeof loginSchema>;
export type LoginResponse = z.infer<typeof loginResponseSchema>;
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;
export type ChangePasswordPayload = z.infer<typeof changePasswordPayloadSchema>;
